<style scoped></style>
<template>
  <swiper-content isProduct :contentEnabled="contentEnabled">
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout page-layout-product">
          <div class="content clue">
            <h2>YOU'VE FOUND COIN NO.1</h2>
            <p>Awesome! You’ve found the first of three hidden 5G coins in our
            hidden coin contest. Move on to the next location with this clue:</p>         
            <h2>2x lower latency and faster response times means gaming like a pro.</h2>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  name: "Coin1Page",
  data: function () {
    return {};
  },
  props: {
    contentEnabled: Boolean,
  },
  methods: {},
};
</script>

<style scoped></style>
